import React from 'react';
import GamesListing from 'components/manager/facilitator/gamesListing/container';
export default function ViewGames() {
    return (React.createElement("div", { className: "wrapper wrapper--alternate" },
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "container" },
                React.createElement(GamesListing, null)))));
}
